// copy-text.js — click an element to copy a string, with inline confirmation.
//
// USAGE:  <button type="button" data-copy-text="counselor@sundae.school">counselor@sundae.school</button>
//         optional: data-copy-done="Copied!"   (defaults to "Copied to clipboard!")
//
// The listener is DELEGATED on `document`, deliberately. The first consumer lives inside the size
// guide's <template>, which ss-modal CLONES into the modal on open — so the button does not exist at
// load time and could never be bound directly. Delegation means clones, re-renders and any future
// consumer work with zero wiring (same reason the zoom and quick-view triggers are delegated).
//
// The element's own text is what gets swapped, so it must be the label — don't hang this on a wrapper
// that contains other markup, or the swap will eat it.
//
// Also consumed by assets/rte-links.js, which stamps data-copy-text onto mailto: links inside
// merchant rich text. Two blocks now load this file (size-guide + info-accordion), so a page can
// execute it twice — hence the bind-once guard below. Without it each click would attach a second
// revert timer to the same element.
(function () {
  if (window.__copyTextBound) return;
  window.__copyTextBound = true;

  var DONE_DEFAULT = 'Copied to clipboard!';
  var REVERT_MS = 2000;

  function copy(text) {
    // navigator.clipboard needs a secure context. Shopify is https, but `theme dev` over a plain-http
    // LAN address is NOT secure, and neither are older Safaris — hence the fallback, or the feature
    // would appear broken in exactly the place it gets tested.
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      // Off-screen rather than display:none — a hidden textarea cannot be selected.
      ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (err) {
        reject(err);
      } finally {
        document.body.removeChild(ta);
      }
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var el = event.target.closest('[data-copy-text]');
    if (!el) return;

    var text = el.getAttribute('data-copy-text');
    if (!text) return;

    copy(text)
      .then(function () {
        // Cache the original ONCE. Without this guard a second click while the confirmation is still
        // showing would cache "Copied to clipboard!" as the original and the address never returns.
        if (el.__copyOriginal == null) el.__copyOriginal = el.textContent;
        clearTimeout(el.__copyTimer);

        el.textContent = el.getAttribute('data-copy-done') || DONE_DEFAULT;
        el.classList.add('is-copied');

        el.__copyTimer = setTimeout(function () {
          el.textContent = el.__copyOriginal;
          el.classList.remove('is-copied');
        }, REVERT_MS);
      })
      .catch(function () {
        // Silent on purpose: the address stays on screen, so the visitor can still select it by hand.
        // A failure alert would be worse than the fallback that already exists.
      });
  });
})();
